import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { City } from '../../models/city';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})

export class CityService {
  constructor(
    private http: HttpClient
  ) {
  }

  public getAll() {
    return this.http.get<{
      docs: Array<City>
    }>(environment.host + '/cities');
  }
}
